import React, { Component } from 'react';

export default class SubmitIcon extends Component {

    render(){
        const fillStyle = {fill:this.props.fillColor}
        return (
            <svg width="100%" height="100%" viewBox="0 0 80 80" style={this.props.svgStyle}>
              <g style={fillStyle}>
                <path d="M40,5.551c19.013,0 34.449,15.436 34.449,34.449c0,19.013 -15.436,34.449 -34.449,34.449c-19.013,0 -34.449,-15.436 -34.449,-34.449c0,-19.013 15.436,-34.449 34.449,-34.449Zm-15.662,29.187c1.186,0.209 1.456,0.443 2.109,1.059l9.186,9.186l18.079,-18.07c2.853,-2.394 8.644,1.743 5.145,5.453l-20.573,20.572c-0.516,0.487 -0.704,0.578 -1.066,0.747c-1.398,0.651 -2.882,0.532 -4.237,-0.747l-11.838,-11.838c-2.123,-2.251 -0.604,-6.596 2.979,-6.387c0.072,0.008 0.144,0.017 0.216,0.025Z"/>
              </g>
            </svg>
        )
    }
}
